import Bloc from './Bloc.js';
import Types from './Types.js';

export default class ClearGlobalVariable extends Bloc {

	constructor (src, ctx) {

		super("clearfvar", src, ctx, true);
		this.f = (src, ins) => {
			src.master.clearVariable(ins[0]);
			return [];
		};
		this.types = [Types.string];
	}
}